<template>
  <el-dialog :visible.sync="visible" width="55%">
    <template slot="title">
      <div class="header">
        <span class="title">{{ labels.title }}</span>
        <span class="sub-title">{{ labels.subTitle }}</span>
      </div>
    </template>
    <div class="content">
      <p v-for="(paragraph, index) in labels.paragraphs" :key="index">
         {{ paragraph }}
      </p>
      <p>
         <strong>{{ labels.disclaimer.title }}</strong>:
         {{ labels.disclaimer.description }}
      </p>
      <hr />
      <div class="footer">
        <el-button @click="visible = false">{{labels.close}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { bus } from '../../main';
import { about } from '../../js/labels';
import { Dialog, Button } from "element-ui";

export default {
   components: {
      "el-dialog": Dialog,
      "el-button": Button,
   },
   data() {
      return {
         firstClose: true,
      }
   },
   props: {
      show: {
         type: Boolean,
         required: true,
      },
      languageIsEnglish: {
         type: Boolean,
         required: true,
      }
   },
   computed: {
      labels() {
         return this.languageIsEnglish ? about.english : about.nepali;
      },
      visible: {
         get() {
            return this.show;
         },
         set(value)
         {
            if (this.firstClose)
            {
               bus.$emit('start-intro');
               this.firstClose=false;
            }
            this.$emit('change-show', value);
         }
      }
  }
};
</script>

<style lang="scss" scoped>
.header {
  text-align: center;
  // text-transform: uppercase;
  font-weight: 500;
  .title {
    font-family: "Montserrat", sans-serif;
    display: block;
    font-size: 20px;
    margin: 3px;
  }
  .sub-title {
    font-family: "Montserrat", sans-serif;
    font-size: 20px;
  }
}

.content {
  padding: 1em 3em;
  font-size: 14px;
  p {
    font-size: 14px;
    color: #333;
    line-height: 1.4rem;
    margin: 0.8rem 0;
    text-align: justify;
    word-break: break-word;
  }
  .footer button {
    float: right;
    margin: 0.5rem 0 1rem 0;
  }
}
</style>